export default {
  0: { imageWidth: 480 },
  1: { imageWidth: null, rubricWithBg: true, small: true },
  2: { imageWidth: 291, clippedImage: true },
  3: { imageWidth: 250, clippedImage: true, small: true },
};
